export const AuthEndpoints = {
  getSessions: 'getSessions',
} as const;
